export const izjava_nezaposlenje_pk= {
    templateId: 235,
    category: 4,
    templateTitle: 'Izjava o nezapošljavanju nakon prestanka radnog odnosa (radi obračuna poreznih olakšica nakon prestanka radnog odnosa)',
    templateDescription: `<p>Poslodavac koji obračunava plaću radnika nakon prestanka radnog odnosa (nakon odjave) više ne smije obračunati plaću temeljem olakšica iz porezne kartice, osim ako radnik da poslodavcu posebnu izjavu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Osobni odbitak neoporezivi dio je dohotka radnika, a čini ga osnovni osobni odbitak koji se uvećava za uzdržavane članove uže obitelji, djecu i invalidnost.</p>
    <p>Poslodavac obračunava osobni odbitak prema poreznoj kartici radnika.</p>
    <p><strong>Od 01.01.2018. vrijedi pravilo da poslodavac koji obračunava plaću radnika nakon prestanka radnog odnosa (nakon odjave) više ne smije obračunati plaću temeljem olakšica iz porezne kartice, osim ako radnik da posebnu izjavu da neće zasnovati novi radni odnos u mjesecu raskida radnog odnosa ili sljedećem mjesecu.</strong><p>    <p></p>
    <p>To proizlazi iz <a target="_blank" href="https://www.porezna-uprava.hr/HR_publikacije/Lists/mislenje33/Display.aspx?id=19582" ">mišljenja</a> porezne uprave, Broj klase:410-01/18-01/218, Urudžbeni broj:513-07-21-01/18-2, Zagreb, 09.02.2018  koje ostavlja takvu mogućnost.</p>
    <p>Naime, u praksi se javlja problem da radnik kojemu prestaje radni odnos (dakle ne zapošljava se kod drugog poslodavca) izlazi u susret Poreznoj upravi na način da neobračunom osobnih odbitaka početno plaća veći iznos poreza, a zbog nekorištenja olakšica iz porezne kartice.</p>
    <p><strong>Posebno se naglašava da i neobračunom osobnih odbitaka temeljem ove izjave, radnik ne može biti oštećen, nego će samo "kreditirati" Poreznu upravu. To iz razloga što će svoja zakonska prava ostvariti u posebnom postupku godišnjeg obračuna poreza na dohodak, kojega Porezna uprava provodi, po službenoj dužnosti, za sve porezne obveznike poreza na dohodak od nesamostalnog rada i drugog dohotka.</strong></p>
    <p>Ukoliko poslodavac želi izaći u susret radniku kojemu prestaje radni odnos i ne zapošljava se kod drugog poslodavca i obračunati mu plaću uzimajući u obzir osobne odbitke prema poreznoj kartici (radnik dobiva veću plaću u odnosu na obračun plaće bez osobnih odbitaka), može ishoditi izjavu radnika, čiji primjer se daje u nastavku.    </p>
    <p>Ipak, poslodavac isplatitelj plaće, pri isplati plaće bivšim radnicima za posljednji mjesec rada, ima uvid u poreznu karticu bivšeg radnika, a najkasnije do dana dospjelosti plaće za posljednjih mjesec rada te može pri utvrđivanju predujma poreza na dohodak od nesamostalnog rada odnosno pri isplati plaće bivšem radniku za posljednji mjesec rada koristiti tako dostupne podatke za neiskorišteni iznos osobnog odbitka.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
      inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
      
    headline: "upućuje sljedeću",
    title: "IZJAVU",
  
    noArticleNumbers: true,
  
    articles: [
    {
      title: "",
      dummy: "true",
      mandatory: false,
      statements: [
      {
        type: "input",
        mandatory: true,
        editable: false,
        parts: [
          { type: "text", content: "kojom ja, gore navedeni, izjavljujem da poslije prestanka radnog odnosa kod Poslodavca " },
          { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
          { type: "text", content: "," },
          { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
          { type: "text", content: ", OIB:" },
          { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
          { type: "text", content: ", tj. od dana" },
          { type: "input",  required: true, placeholder: "Datum odjave radnika." },
          { type: "text", content: "godine, neću u mjesecu prestanka radnog odnosa odnosno u sljedećem mjesecu nakon prestanka radnog odnosa zasnovati novi radni odnos kod drugog poslodavca.          " },
        ],
        value:"",
      }]
    },
    {
      title: "",
      mandatory: false,
      dummy: "true",
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ova Izjava daje u svrhu obračunavanja poreznih olakšica iz porezne kartice i nakon prestanka radnog odnosa kod Poslodavca."
        }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures   
      statements: [],
    },
    {
      static: true,
      mandatory: true,
      editable: true,
      type: 4, 
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "\r\nPoslodavac svojim potpisom potvrđuje primitak Izjave dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
          },
        ],
      },
  ],
  };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/240_izjava_nezaposlenje_pk.ts